import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICustomerGroup } from "src/models/Customers/CustomerGroup.models";

interface CustomerGroupState {
  customerGroups: ICustomerGroup[];
  customerGroupToEdit: ICustomerGroup | null;
}

const initialState: CustomerGroupState = {
  customerGroups: [],
  customerGroupToEdit: null,
};

const customerGroupSlice = createSlice({
  name: "CustomerGroup",
  initialState,
  reducers: {
    setCustomerGroupList: (state, action: PayloadAction<ICustomerGroup[]>) => {
      state.customerGroups = action.payload;
    },
    concatListCustomerGroup: (
      state: CustomerGroupState,
      action: PayloadAction<ICustomerGroup[]>
    ) => {
      state.customerGroups = [...state.customerGroups.concat(action.payload)];
    },
    setCustomerGroupToEdit: (
      state,
      action: PayloadAction<ICustomerGroup | null>
    ) => {
      state.customerGroupToEdit = action.payload;
    },
    addCustomerGroup: (state, action: PayloadAction<ICustomerGroup>) => {
      state.customerGroups.push(action.payload);
    },
    updateCustomerGroup: (state, action: PayloadAction<ICustomerGroup>) => {
      let itemIndex = state.customerGroups.findIndex(
        item => item.customerGroupId === action.payload.customerGroupId
      );
      if (itemIndex !== -1) state.customerGroups[itemIndex] = action.payload;
    },
    deleteCustomerGroup: (state, action: PayloadAction<number>) => {
      const newArray = state.customerGroups.filter(
        item => item.customerGroupId !== action.payload
      );
      state.customerGroups = newArray;
    },
  },
});

export const {
  setCustomerGroupList,
  concatListCustomerGroup,
  setCustomerGroupToEdit,
  addCustomerGroup,
  updateCustomerGroup,
  deleteCustomerGroup,
} = customerGroupSlice.actions;

export default customerGroupSlice.reducer;
